export default __webpack_public_path__ + "static/media/logo.9e82d861.png";